module.exports = __webpack_public_path__ + "static/scroll_heatmap_monthly-76d54b401b51ba95ee27f7ecd579486a.jpg";